// src/store/selectors/uiSelectors.js
import { createSelector } from '@reduxjs/toolkit';

export const selectUI = (state) => state.ui;

export const selectLoading = createSelector([selectUI], (ui) => ui.loading);

export const selectLoadingByKey = (key) => createSelector([selectLoading], (loading) => loading[key] || false);

export const selectErrors = createSelector([selectUI], (ui) => ui.errors);

export const selectErrorByKey = (key) => createSelector([selectErrors], (errors) => errors[key] || null);

export const selectNotifications = createSelector([selectUI], (ui) => ui.notifications);

export const selectUnreadNotifications = createSelector([selectNotifications], (notifications) => notifications.filter((n) => !n.read));

export const selectNotificationCount = createSelector([selectUnreadNotifications], (notifications) => notifications.length);

export const selectModals = createSelector([selectUI], (ui) => ui.modals);

export const selectModalByName = (modalName) => createSelector([selectModals], (modals) => modals[modalName] || { isOpen: false });

export const selectSidebar = createSelector([selectUI], (ui) => ui.sidebar);

export const selectIsSidebarCollapsed = createSelector([selectSidebar], (sidebar) => sidebar.isCollapsed);

export const selectIsMobileSidebarOpen = createSelector([selectSidebar], (sidebar) => sidebar.isMobileOpen);

export const selectSidebarWidth = createSelector([selectSidebar], (sidebar) => sidebar.width);

export const selectBreadcrumbs = createSelector([selectUI], (ui) => ui.breadcrumbs);

export const selectPageTitle = createSelector([selectUI], (ui) => ui.pageTitle);

export const selectGlobalSearch = createSelector([selectUI], (ui) => ui.globalSearch);

export const selectTables = createSelector([selectUI], (ui) => ui.tables);

export const selectTableByName = (tableName) => createSelector([selectTables], (tables) => tables[tableName] || {});

export const selectTableSort = (tableName) =>
    createSelector([selectTableByName(tableName)], (table) => ({
        sortBy: table.sortBy || 'name',
        sortOrder: table.sortOrder || 'asc'
    }));

export const selectTableSelectedRows = (tableName) => createSelector([selectTableByName(tableName)], (table) => table.selectedRows || []);

export const selectIsAnyLoading = createSelector([selectLoading], (loading) => Object.values(loading).some((isLoading) => isLoading));

export const selectHasErrors = createSelector([selectErrors], (errors) => Object.values(errors).some((error) => error !== null));
